import "./OurServices.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import ParentEducation from "./sections/ParentEducation";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function OurServicesPage() {
  return <div>
      <Header />
      <Services />
      <ParentEducation />
      <Faq />
      <Footer />
    </div>;
}